<template>
  <div class="bg2">
    <!-- <Header title="退款" background="#ffffff"></Header> -->
    <div class="goodsDetial">
      <h5>商品详情</h5>
      <p class="line"></p>
      <div class="list flex-center" v-for="item in orderDetails.goodsList">
        <img :src="item.goodsThumb" alt="" />
        <div class="orderMsg">
          <p>{{item.goodsTitle}}</p>
          <p>{{item.unitPriceJP}}日元({{item.unitPrice}}人民币)</p>
        </div>
      </div>
    </div>
    <div class="reason">
      <h5>退款原因</h5>
      <div class="bottom flex-between" @click="show=true">
        <input v-model="radio" type="text" readonly placeholder="请选择退款原因" />
        <img src="../../assets/my/more@2x (2).png" alt="" />
      </div>
    </div>

    <div class="money">
      <h5>退款金额</h5>
      <p>{{orderDetails.price}}人民币</p>
    </div>

    <div class="shuoMing money">
      <h5>退款说明</h5>
      <input type="text" v-model="content" placeholder="请填写退款说明" />
    </div>
    <div class="upload">
      <h5>上传凭证</h5>
      <van-uploader :after-read="afterRead" :deletable="false" v-model="fileList" multiple :max-count="3" />
    </div>
    <div class="btnCom" @click="btnCom">提交申请</div>
    <van-popup v-model="show" round  position="bottom" :style="{ height: '30%' }">
      <div class="hidden">
        <h5>退款原因</h5>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              :title="item.name"
              clickable
			  @click="change(item.name)"
              v-for="item in reason"
              :key="item.id"
            >
              <template #right-icon>
                <van-radio checked-color="#ee0a24" :name="item.name" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      fileList: [],
	  newFileList:[],
	  content:'',
      show: false,
      radio: "",
	  orderDetails:'',
      reason: [
        {
          name: "卖家取消订单",
          id: "1",
        },
        {
          name: "发错商品",
          id: "2",
        },
        {
          name: "其他",
          id: "3",
        },
      ],
    };
  },
  computed: {
	  
  },
  mounted() {
  	this.orderDetails = JSON.parse(this.$route.query.id)
	console.log(this.orderDetails,3)
  },
  methods: {
    change(id) {
      this.radio = id;
	  this.show = false
    },
	btnCom(){
		if(!this.radio){
			this.$toast('请选择退款原因')
			return;
		}
		this.$post({
		  url: "/portal/Shop",
		  module: "Order",
		  interface: "3005",
		  data: {
			  id:this.orderDetails.id,
			  reason:this.radio,
			  content:this.content,
			  images:this.newFileList,
		  },
		}).then((res) => {
			this.$toast('提交成功')
			this.$router.go(-1)
		})
	},
	//上传附件
	afterRead(file){console.log(file,222)
		file.status = 'uploading';
		file.message = '上传中...';
		var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
		formData.append('file', file.file); //接口需要传的参数
		this.$post({
		  url: "/upload",
		  data: formData,
		}).then((res) => {
			file.status = 'done';
			this.newFileList.push(res.file)
			// this.$toast('提交成功')
		})
	}
  },
};
</script>

<style lang='less' scoped>
/deep/ .van-uploader__preview {
  margin-right: 20px;
}
.line {
  height: 2px;
  background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
  opacity: 0.3;
}
.goodsDetial {
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  padding-bottom: 30px;
  margin-top: 14px;
  h5 {
    height: 50px;
    padding-left: 15px;
    line-height: 50px;
    font-size: 16px;
  }

  .list {
    padding-top: 16px;
    padding-left: 16px;
    img {
      width: 88px;
      height: 82px;
      margin-right: 10px;
    }
    .orderMsg {
      height: 70px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      color: #303133;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
      p:nth-child(2) {
        font-size: 13px;
        color: #fd0212;
      }
    }
  }
}
.reason {
  margin: 14px 0;
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  padding: 0 15px;
  h5 {
    height: 50px;
    line-height: 50px;
  }
  .bottom {
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.money {
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  padding-left: 15px;
  h5 {
    height: 50px;
    line-height: 50px;
  }
  p {
    color: #fd0212;
  }
}
.shuoMing {
  margin-top: 14px;
}
.upload {
  height: 148px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
  border-radius: 12px;
  margin-top: 14px;
  font-size: 13px;
  padding: 0 14px;
  h5 {
    height: 40px;
    line-height: 40px;
  }
}
.btnCom {
  width: 90%;
  margin: 72px 5% 10px;
}
.hidden {
  height: 50px;
  line-height: 50px;
  h5 {
    text-align: center;
  }
}
</style>
